import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { style: {"position":"relative","height":"100%"} }

import { computed, StyleValue } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'tlColumns',
  props: {
  content: {
    type: Object,
    required: true,
  }
},
  setup(__props) {

const props = __props;

const styleDiv = computed<StyleValue>(() => {
  return {
    position: 'absolute',
    height: '100%',
    left: props.content.x * 100 + "%",
    width: props.content.width * 100 + "%",
    backgroundColor: "rgb(236, 236, 236)"
  };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.content.width > 0)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          style: _normalizeStyle(styleDiv.value)
        }, null, 4))
      : _createCommentVNode("", true)
  ]))
}
}

})